import React, {useEffect} from 'react';
import '../styles/Blog.css'; // You can create this file for specific styling

const Blog = () => {
    useEffect(() => {
        document.title = 'Blog | Bularis Tech';
      }, []);
      
  return (
    <div className="blog">
      <div className="blog-header">
        <h1>Blog</h1>
        <p>Stay updated with our latest posts and articles.</p>
      </div>
      <div className="blog-posts">
        <div className="blog-post">
          <h2>How to Start a Tech Business</h2>
          <p>Starting a tech business is an exciting journey. Here’s everything you need to know...</p>
        </div>
        <div className="blog-post">
          <h2>Why Web Design Matters</h2>
          <p>Web design plays a key role in user experience. In this post, we explain why design is crucial for business success...</p>
        </div>
      </div>
    </div>
  );
}

export default Blog;
